import { z } from 'zod';
import { sectionHasValue } from '../util';
export const baseLungAuscultationSchema = z.object({
    wnl: z.boolean().optional(),
    upperRight: z.string().optional(),
    upperLeft: z.string().optional(),
    midRight: z.string().optional(),
    midLeft: z.string().optional(),
    lowerRight: z.string().optional(),
    lowerLeft: z.string().optional(),
    details: z.array(z.string()).optional(),
});
export const baseLungAuscultationSchemaRefined = baseLungAuscultationSchema.refine((data) => sectionHasValue(data), {
    message: 'Mark as within normal limits if none applies',
    path: [],
});
export const baseBreathingPatternSchema = z.object({
    shortness: z.string().optional(),
    mrcScale: z.string().optional(),
    breathingPattern: z.string().optional(),
    accessoryMuscleUse: z.string().optional(),
    pursedLipBreathing: z.string().optional(),
});
export const baseCpapBipapSchema = z.object({
    papTherapy: z.string().optional(),
    cpapPressure: z.string().optional(),
    cpapMaskType: z.string().optional(),
    cpapCompliance: z.string().optional(),
    cpapAdherence: z.string().optional(),
    bipapIpap: z.string().optional(),
    bipapEpap: z.string().optional(),
    bipapBackupRate: z.string().optional(),
    bipapMaskType: z.string().optional(),
    bipapCompliance: z.string().optional(),
    bipapAdherence: z.string().optional(),
});
export const baseMechanicalVentilatorSchema = z.object({
    ventilatorInUse: z.string().optional(),
    ventMode: z.string().optional(),
    tidalVolume: z.string().optional(),
    fio2: z.string().optional(),
    peep: z.string().optional(),
    setRate: z.string().optional(),
    pressureSupport: z.string().optional(),
    patientTriggeredBreaths: z.string().optional(),
    alarms: z.string().optional(),
    settingsMatchOrders: z.string().optional(),
    ventCircuit: z.string().optional(),
});
export const baseTracheostomySchema = z.object({
    tracheostomyPresent: z.string().optional(),
    tubeType: z.string().optional(),
    tubeSize: z.string().optional(),
    lastTubeChange: z.string().optional(),
    stomaSiteAssessment: z.string().optional(),
    secretionManagement: z.string().optional(),
    innerCannula: z.string().optional(),
    suctioning: z.string().optional(),
    trachCareBy: z.string().optional(),
});
export const baseSmokingHistorySchema = z.object({
    smokingStatus: z.string().optional(),
    packYears: z.string().optional(),
    quitYear: z.string().optional(),
    vape: z.string().optional(),
});
export const baseRespiratoryTreatmentsSchema = z.object({
    nebulizerTreatment: z.string().optional(),
    nebulizerTreatmentNotes: z.string().optional(),
    mdiInhaler: z.string().optional(),
    mdiInhalerNotes: z.string().optional(),
    incentiveSpirometry: z.string().optional(),
    chestPt: z.string().optional(),
});
export const baseCoughSchema = z.object({
    cough: z.string().optional(),
    color: z.string().optional(),
    amount: z.string().optional(),
});
